<template>
	<div>
		<div class="title">选择经营行业，可快速添加商品</div>
		<div class="content">
			<div v-for="(item,index) in industryList" :key="index">
				<div @click="jump(item)" >
					<div>{{item}}</div>
					<div>></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				industryList:[]
			}
		},
		created() {
				this.getIndustry()
		},
		methods:{
			jump(item){
				// this.$router.push('/SellType')
				this.$router.push({path:"/SellType", query:{industry:item}})
			},
			getIndustry() {
			    this.$http.post('/wechat/api.food_library/getIndustry').then(response => {
			        if (response && response.body.code== 200) {
			            this.industryList=response.body.data
							  console.log(this.foodList)
						// response.body.rows.map(item=>{
						// 	item.name=item.store_name;
						// })
			        }
			    })
			},
		}
	}
</script>

<style scoped="scoped">
	.title{
		width: 100%;
		text-align: center;
		font-size: 0.5rem;
		margin: 0.5rem 0;
	}
	.content{
		width: 100%;
	}
	.content>div>div{
		width: 90%;
		border: 1px solid #F0F0F0;
		border-radius: 0.1rem;
		background-color: #FFFFFF;
		margin: 0 auto;
		margin-top: 0.2rem;
		padding:0.4rem 0.2rem;
		font-size: 0.4rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.content>div>div>div:nth-of-type(2){
		color: #999;
	}
</style>
